import Typography from '@mui/material/Typography';
import { FooterAction, Row } from '../../interfaces';
import { getFullName } from '../../helpers/global';
import { WaiverRequestWithCustomerAndEvents } from '../../types/waivers';
import WaiverStatusBadge from '../../components/waivers/WaiverStatusBadge';
import {
  getWaiverLastUpdateText,
  getWaiverNextUpdateText,
} from '../../helpers/waivers';
import DropdownMenu from '../../components/global/DropdownMenu';
import { HeaderCells } from '../../types/ui';

export const headerCells = [
  { id: 'customer', label: 'Client' },
  { id: 'status', label: 'Waiver status' },
  { id: 'Last update', label: 'Last update' },
  { id: 'Next update', label: 'Next update' },
  { id: 'empty', label: '' },
] as const satisfies HeaderCells;

// Function to create a table row from a single waiver request
function createRow(
  waiverRequest: WaiverRequestWithCustomerAndEvents,
  createMoreActions: (
    waiver: WaiverRequestWithCustomerAndEvents,
  ) => FooterAction[],
) {
  const customerName = getFullName({
    firstName: waiverRequest.customer.user.firstName,
    lastName: waiverRequest.customer.user.lastName,
  });

  const moreActions = createMoreActions(waiverRequest);

  const row = {
    rowId: waiverRequest.id,
    cells: [
      <Typography variant="body1">{customerName}</Typography>,
      <WaiverStatusBadge status={waiverRequest.status} />,
      <Typography variant="body1">
        {getWaiverLastUpdateText(waiverRequest)}
      </Typography>,
      <Typography variant="body1">
        {getWaiverNextUpdateText(waiverRequest)}
      </Typography>,
      <DropdownMenu options={moreActions} />,
    ],
  };

  return row;
}

// Function to create all rows for an array of waiver requests
export function createRows({
  items,
  createMoreActions,
}: {
  items: WaiverRequestWithCustomerAndEvents[] | undefined;
  createMoreActions: (
    waiver: WaiverRequestWithCustomerAndEvents,
  ) => FooterAction[];
}) {
  if (!items) {
    return [];
  }

  const rows: Row[] = [];
  items.forEach(item => {
    rows.push(createRow(item, createMoreActions));
  });
  return rows;
}
